// extracted by mini-css-extract-plugin
module.exports = {"root":"AddPhysicianModal_root__3EFw6","buttonGroup":"AddPhysicianModal_buttonGroup__3GY_d","modalHeader":"AddPhysicianModal_modalHeader__1v9ui"};